import './App.css';
import { Route, Routes } from 'react-router-dom';
import LogoutPage from './pages/Logout';
import GlobalProvider from './context/GlobalProvider';
import RegisterPage from './pages/Register';

function App() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  return (
    <div className="App">
        <GlobalProvider>
          <Routes>
              <Route path='/Logout' exact urlParams={urlParams} element={<LogoutPage />} />
              <Route path='/:company?' exact urlParams={urlParams} element={<RegisterPage />} />
          </Routes>
        </GlobalProvider>
    </div>
  );
}

export default App;